import React from "react";
import { useContent } from "../context/ContentContext";
import Header from "../components/Header";
import EditToolbar from "../components/EditToolbar";
import { SECTION_COMPONENTS } from "../components/sections";

export default function LandingPage() {
  const { content, loading, editMode, isAdmin } = useContent();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-white">
        <div className="font-heading text-xl text-[var(--navy)]">
          Loading…
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      {editMode && isAdmin && (
        <div
          className="sticky top-0 z-40 w-full py-1.5 text-center text-xs font-semibold text-white"
          style={{ backgroundColor: content.theme.red }}
        >
          EDIT MODE — click any text to edit, hover images &amp; sections for controls
        </div>
      )}
      <Header />
      <main>
        {content.sections.map((section) => {
          const Comp = SECTION_COMPONENTS[section.type];
          if (!Comp) return null;
          return <Comp key={section.id} section={section} />;
        })}
      </main>
      <EditToolbar />
    </div>
  );
}
